module.exports = __webpack_public_path__ + "img/PanProjection.de0d28a3.png";